import {
    MapFbiToHtmlColor,
} from '../query-colour-mapper'

/**
 * Hourly data should have the following structure:
 * {
 *      DF: "string",
 *      DateTime: "string",
 *      Direction: "string",
 *      FBI: "string",
 *      FDR: "string",
 *      Humidity: "string",
 *      Speed: "string",
 *      Temperature: "string"
 * }
 * @param {*} hourlyData 
 * @param {*} detailsContainer 
 */
export function drawFbiColumnChart(hourlyData, detailsContainer, chartHeight) {
    // Create the temperature data array
    const temp = [['Datetime', 'FBI', { role: "style" }]];

    hourlyData.forEach((item) => {
        temp.push([
            new Date(item['DateTime']), +item['FBI'], MapFbiToHtmlColor(+item['FBI'])
        ]);
    })

    const data = google.visualization.arrayToDataTable(temp);

    var options = {
        title: "Fire Behaviour Index",
        chartArea: {width: '85%'},
        bar: {groupWidth: "90%"},
        legend: { position: "none" },
        vAxis: {
            maxValue: 100,
            ticks: [0, 12, 25, 50, 75, 100]
        },
        height: +chartHeight.slice(0, -2)
      };

    const chartContainer = $(`<div class="no-data ` + 
            `column-chart-container ` + 
            `chart-container-style" ` + 
            `id="fbi-column-chart-id"` + 
            `style="height:${chartHeight};"></div>`);
    detailsContainer.append(chartContainer);

    const chart = new google.visualization.ColumnChart(document.getElementById('fbi-column-chart-id'));
    chart.draw(data, options);
}